
import { defineComponent, ref, reactive, toRefs, onMounted, nextTick } from 'vue'
import { ClockCircleOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import Descriptions from '@/components/descriptions.vue'
import f10Api from '@/api/f10Api'
import globalsets from '@/utils/globalsets'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  components: { Descriptions },
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    token: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  setup(props, context) {
    const pageData: any = reactive({
      list: [],
      opencontent1: false,
      opencontent2: false,
      open1: false,
      open2: false,
      info: {},
      spinning: true
    })
    pageData.list = [
      {
        title: '上市日',
        key: 'ListDate',
        opencontent: false,
        open: false
      },
      {
        title: '上市至今涨跌幅',
        key: 'UpDown',
        opencontent: false,
        open: false
      },
      {
        title: '发行价格(元)',
        key: 'IssuePrice',
        opencontent: false,
        open: false
      },
      {
        title: '发行面值(元)',
        key: 'ParValue',
        opencontent: false,
        open: false
      },
      {
        title: '发行前总股本(股)',
        key: 'TotalSharesBeforeIssue',
        opencontent: false,
        open: false
      },
      {
        title: '发行数量(股)',
        key: 'IssueVol',
        opencontent: false,
        open: false
      },
      {
        title: '首次上市流通数量(股)',
        key: 'OutstandingShares',
        opencontent: false,
        open: false
      },
      {
        title: '发行市盈率(全面摊薄)(倍)',
        key: 'WeightedPERatio',
        opencontent: false,
        open: false
      },
      {
        title: '募集资金总额(元)',
        key: 'IPOProceeds',
        opencontent: false,
        open: false
      },
      {
        title: '募集资金净额(元)',
        key: 'IPONetProceeds',
        opencontent: false,
        open: false
      },
      {
        title: '发行方式',
        key: 'IssueMethod',
        opencontent: false,
        open: false
      },
      {
        title: '承销方式',
        key: 'UnderwritingMode',
        opencontent: false,
        open: false
      },
      {
        title: '主承销商',
        key: 'LeadUnderwriter',
        opencontent: false,
        open: false
      },
      {
        title: '保荐机构',
        key: 'SponsorName',
        opencontent: false,
        open: false
      },
      {
        title: '发行对象',
        key: 'IssueObject',
        opencontent: false,
        open: false
      }
    ]
    const route: any = useRoute()
    function getipoinfo() {
      const data: any = {}
      // 0：日期（默认），1：股票ID，2：评价，3：变动（1为首次,2为调高,3为调低,4为维持），4：目标价，5：机构，6：作者
      // 0:desc（默认）,1:asc
      data.data = {
        ExchangeID: route.query.market,
        InstrumentID: route.query.code
      }
      data.headers = {
        token: props.token
      }
      f10Api.getipoinfo(data).then((res: any) => {
        const _data = JSON.parse(JSON.stringify(res.Data)) || {}
        if (Object.keys(_data).length) {
          _data.IssuePrice = _data.IssuePrice ? _data.IssuePrice.toFixed(2) : '—'
          _data.ParValue = _data.ParValue ? _data.ParValue.toFixed(2) : '—'
          _data.WeightedPERatio = globalsets.getNumber(_data.WeightedPERatio)
          _data.TotalSharesBeforeIssue = globalsets.getNumber(_data.TotalSharesBeforeIssue)
          _data.IssueVol = globalsets.getNumber(_data.IssueVol)
          _data.OutstandingShares = globalsets.getNumber(_data.OutstandingShares)
          _data.IPOProceeds = globalsets.getNumber(_data.IPOProceeds)
          _data.IPONetProceeds = globalsets.getNumber(_data.IPONetProceeds)
          _data.ListDate = _data.ListDate ? window.moment(_data.ListDate * 1000).format('YYYY-MM-DD') : '—'
          _data.UpDown = _data.UpDown != null ? (_data.UpDown * 100).toFixed(2) + '%' : '—'
        }
        pageData.info = _data
        pageData.spinning = false
      })
    }
    getipoinfo()
    return {
      ...toRefs(pageData)
    }
  }
})
